<template>
  <el-row>
    <el-col>
      <div class="form-module-tit">{{ $locale('movie.coverAndTrailer') }}</div>
      <el-form-item :label="$locale('movie.cover')" prop="posters">
        <div class="movie-img-list">
          <UploadContainer
            :type="'B'"
            :imageList="[convertImageUrl(formData.posters)]"
            :placeholder="$locale('movie.plsUploadCover')"
            :itemHeight="300"
            @onSuccess="({response}) => uploadSuccess(response, 'posters')"
            @onDelete="deleteImg('posters')"
          ></UploadContainer>
        </div>
      </el-form-item>

      <el-form-item :label="$locale('movie.picture')" prop="stills">
        <div class="movie-img-list">
          <UploadContainer
            :type="'B'"
            :imageList="formData.stills"
            :limit="10"
            :placeholder="$locale('movie.plsUploadPic')"
            :itemWidth="170"
            :itemHeight="170"
            @onSuccess="({response}) => uploadSuccess(response, 'stills')"
            @onDelete="idx => deleteImg('stills', idx)"
          ></UploadContainer>
        </div>
      </el-form-item>

      <el-form-item :label="$locale('movie.movieTrailer')" prop="trailers" v-if="formData.trailers">
        <el-input
          :placeholder="$locale('movie.plsEnterMovieTrailer')"
          v-model="formData.trailers[0]"
          maxlength="255"
        ></el-input>
      </el-form-item>

      <hr class="dotted" />
    </el-col>
  </el-row>
</template>

<script>
import UploadContainer from "@/components/common/UploadContainer";
import { convertImageUrl } from "@/utils/common";

export default {
  name: "covers-and-trailer",
  components: {
    UploadContainer,
  },
  props: {
    formData: {
      required: true,
      type: Object,
    },
    formRef: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      tokenObj: {
        Authorization: window.localStorage.getItem("token")
      },
      uploadUrl: "/api/system/uploadFile",
      coverFile: "",
      stillsFile: [],
      convertImageUrl,
    };
  },
  methods: {
    uploadSuccess(res, imgType) {
      if (res.success) {
        let obj = this.formData;

        if (imgType == "posters") {
          obj.posters = res.data;
          this.coverFile = "";
        } else {
          obj.stills.push(res.data);
          this.stillsFile = [];
        }
      } else {
        this.$alert(this.$locale("movie.uploadError"), {
          showClose: false
        });
      }
    },
    deleteImg(key, index) {
      switch(key) {
      case "posters":
        this.formData.posters = "";
        break;
      case "stills":
        this.formData.stills.splice(index, 1);
        break;
      default:
        break;
      }
    },
  },
};
</script>